import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import 'chart.js/auto'
import type {IpiVisCancellations} from './_requests'

type Props = {
  data: IpiVisCancellations
}

const PALETTE = ['#a3a242', '#d7383c', '#e5605f', '#f7a6a0', '#f6c9c9', '#c8c85a']

export const CancellationsDonut: React.FC<Props> = ({data}) => {
  const reasons = data.reasons ?? []

  const chartData = {
    labels: reasons.map((r) => r.reason),
    datasets: [
      {
        data: reasons.map((r) => r.count),
        backgroundColor: reasons.map((_, i) => PALETTE[i % PALETTE.length]),
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {legend: {display: false}, tooltip: {enabled: false}},
  }

  return (
    <div className='ipivis-card ipivis-cancellations'>
      <div className='ipivis-cancellations__header'>
        <h3 className='ipivis-cancellations__title'>Cancellations</h3>
        <p className='ipivis-cancellations__subtitle'>Reasons for cancelled appointments.</p>
      </div>

      {reasons.length === 0 ? (
        <div className='ipivis-empty'>No cancellations in the selected range.</div>
      ) : (
        <div className='ipivis-cancellations__body'>
          <div className='ipivis-cancellations__chart-area'>
            <div className='ipivis-cancellations__chart'>
              <Doughnut data={chartData} options={options} />
              <div className='ipivis-cancellations__center'>{data.cancellationRate}%</div>
            </div>
          </div>
          <ul className='ipivis-cancellations__legend'>
            {reasons.map((r, i) => (
              <li key={`${r.reason}-${i}`}>
                <span className='ipivis-cancellations__legend-label'>
                  <span
                    className='ipivis-cancellations__dot'
                    style={{backgroundColor: PALETTE[i % PALETTE.length]}}
                  />
                  <span className='ipivis-cancellations__reason' title={r.reason}>
                    {r.reason}
                  </span>
                </span>
                <span className='ipivis-cancellations__pct'>{r.percentage}%</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
